import axios, { AxiosResponse } from 'axios';
import { HasSubscriptionResponse } from '~/models';
import { ChatUser } from './TalkJSService';

export type EmailSettings = {
    subscriptions: {
        newsletters: boolean;
    };
};

class CommunicationService {
    static async hasSubscription(id: string) {
        const res: AxiosResponse<HasSubscriptionResponse> = await axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v1/communication/subscriptions?id=${id}`,
        });
        return res.data.hasSubscription;
    }

    static async addSubscription(id: string) {
        const res = await axios({
            method: 'POST',
            url: `${process.env.VUE_APP_API_URL}v1/communication/subscriptions`,
            data: { id },
        });
        return res.status >= 200 && res.status <= 299;
    }

    static async removeSubscription(id: string) {
        const res = await axios({
            method: 'DELETE',
            url: `${process.env.VUE_APP_API_URL}v1/communication/subscriptions`,
            data: { id },
        });
        return res.status >= 200 && res.status <= 299;
    }

    static getEmailSettings(): Promise<EmailSettings> {
        return axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v1/communication/email/settings`,
        }).then((res: AxiosResponse<EmailSettings>) => {
            return res.data;
        });
    }

    static updateEmailSettings(settings: EmailSettings): Promise<EmailSettings> {
        return axios({
            method: 'PUT',
            url: `${process.env.VUE_APP_API_URL}v1/communication/email/settings`,
            data: settings,
        }).then((res: AxiosResponse<EmailSettings>) => {
            return res.data;
        });
    }

    /* Availability */

    static getChatAvilabilityMany(orgIDs: number[]) {
        return axios({
            method: 'POST',
            url: `${process.env.VUE_APP_API_URL}v1/communication/chat/availability/many`,
            data: { ids: orgIDs },
        }).then((res: AxiosResponse<ChatUser[]>) => res.data);
    }

    static getWhereByUrl(id: string) {
        return axios({
            method: 'GET',
            url: `${process.env.VUE_APP_API_URL}v1/communication/video-chat/room/byid/${id}`,
        });
    }
}

export default CommunicationService;
